import { ErrorCode } from '../types'

export const DigiLaErrorCode = {
  ...ErrorCode,
  RepresentativeRightsUnknown: 'REPRESENTATIVE_RIGHTS_UNKNOWN',
  UserIsNotMainAoMember: 'USER_IS_NOT_MAIN_AO_MEMBER',
  DigipaRequired: 'DIGIPA_REQUIRED',
  DigiliRequired: 'DIGILI_REQUIRED',
  GuardianMismatch: 'GUARDIAN_MISMATCH',
} as const

export type DigiLaErrorCode = (typeof DigiLaErrorCode)[keyof typeof DigiLaErrorCode]
